var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFactor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 112,
    height: 112,
    rx: 6,
    fill: "#F5F9FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.3 22.4881V21.7881H60H79.6032C81.0886 21.7881 82.5132 22.3782 83.5636 23.4285C84.6139 24.4789 85.204 25.9034 85.204 27.3889V51.3685C86.3833 51.5026 87.5527 51.7128 88.7048 51.9976V27.3889C88.7048 24.975 87.7459 22.66 86.039 20.9531C84.3321 19.2462 82.0171 18.2873 79.6032 18.2873H57.1283C57.1283 18.2873 57.1282 18.2873 57.1282 18.2873C55.3654 18.2877 53.675 18.9878 52.4281 20.2339L33.2467 39.4202L33.2463 39.4206C31.9986 40.6668 31.2968 42.3574 31.2953 44.1208V86.1984C31.2953 88.6123 32.2542 90.9273 33.9611 92.6342C35.6679 94.341 37.983 95.3 40.3969 95.3H59.8235C59.0013 94.1901 58.2631 93.02 57.6151 91.7992H40.3969C38.9114 91.7992 37.4869 91.2091 36.4365 90.1587C35.3861 89.1084 34.7961 87.6838 34.7961 86.1984V46.992V46.292H35.4961H52.6488C54.4128 46.292 56.1046 45.5913 57.3519 44.3439C58.5993 43.0966 59.3 41.4049 59.3 39.6408V22.4881ZM36.5105 42.7912H34.8206L36.0155 41.5963L54.6043 23.0076L55.7992 21.8126V23.5025V39.6408C55.7992 40.4764 55.4673 41.2777 54.8765 41.8685C54.2857 42.4593 53.4844 42.7912 52.6488 42.7912H36.5105Z",
    fill: "#BCC1DB",
    stroke: "#F5F9FF",
    strokeWidth: 1.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M67.8962 67.4588V64H71.8643L77.7241 67.4588H67.8962Z",
    fill: "url(#paint0_linear_80_4697)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M64.6137 67.4588C64.6585 66.5297 65.0447 65.6846 65.6603 65.0634C66.3151 64.4086 67.2274 64 68.2292 64C70.1769 64 71.7552 65.5391 71.8447 67.4588H64.6137Z",
    fill: "#C2C2C2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M71.864 64V100.636C71.864 102.494 73.3751 104 75.2277 104H102.92V67.6323C102.92 65.6287 101.292 64 99.2769 64H71.864Z",
    fill: "url(#paint1_linear_80_4697)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M78.563 100.894H106.429C106.368 101.716 106.021 102.461 105.472 103.015C105.209 103.272 104.907 103.496 104.571 103.647C104.123 103.871 103.62 103.994 103.088 103.994H75.2217C76.9959 103.994 78.423 102.623 78.563 100.894V100.894Z",
    fill: "#C2C2C2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M99.4575 90.0314H75.3243V92.2085H99.4575V90.0314Z",
    fill: "#BCC1DB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M99.4551 94.4852H75.3219V96.6624H99.4551V94.4852Z",
    fill: "#BCC1DB"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M73.6665 73.4725V69.0323H74.671V73.4725H73.6665Z",
    fill: "#1062D0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M78.7519 73.4725L76.6023 70.6254V73.4725H75.6426V69.0323H76.5575L78.7136 71.8858V69.0323H79.6668V73.4725H78.7519Z",
    fill: "#1062D0"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M81.9004 73.4725L80.1538 69.0323H81.2287L82.4379 72.3784L83.6534 69.0323H84.6899L82.9241 73.4725H81.9004Z",
    fill: "#1062D0"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M89.6097 71.2521C89.6097 72.5316 88.5861 73.5169 87.2233 73.5169C85.867 73.5169 84.8369 72.538 84.8369 71.2521C84.8369 69.9597 85.867 69 87.2233 69C88.5861 69 89.6097 69.9661 89.6097 71.2521V71.2521ZM85.8734 71.2521C85.8734 72.0326 86.5004 72.6404 87.2425 72.6404C87.9847 72.6404 88.5861 72.0326 88.5861 71.2521C88.5861 70.4715 87.9847 69.8765 87.2425 69.8765C86.494 69.8765 85.8734 70.4715 85.8734 71.2521V71.2521Z",
    fill: "#1062D0"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M90.2666 73.4725V69.0323H91.2711V73.4725H90.2666Z",
    fill: "#1062D0"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M96.0533 69.7358L95.4711 70.4459C95.164 70.094 94.7289 69.8701 94.3195 69.8701C93.5581 69.8701 92.9695 70.4587 92.9695 71.2329C92.9695 72.007 93.5581 72.602 94.3195 72.602C94.7161 72.602 95.1576 72.3973 95.4711 72.0838L96.0597 72.7236C95.5926 73.2034 94.9145 73.5169 94.2683 73.5169C92.9439 73.5169 91.9395 72.5316 91.9395 71.2457C91.9395 69.9661 92.9631 69 94.3067 69C94.9401 69 95.6118 69.2879 96.0533 69.7358V69.7358Z",
    fill: "#1062D0"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M97.6524 69.8623V70.8284H99.7957V71.6601H97.6524V72.6454H100.103V73.4771H96.6543V69.037H100.032V69.8687H97.6524V69.8623Z",
    fill: "#1062D0"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_80_4697",
    x1: 70.5,
    y1: 64,
    x2: 75,
    y2: 66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEEFEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7F7F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_80_4697",
    x1: 75.5,
    y1: 99.5,
    x2: 103,
    y2: 64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E7E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2F3F3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFactor);
export default __webpack_public_path__ + "static/media/Factor.c90bcb03f1176cd67f26ecde48b21dfd.svg";
export { ForwardRef as ReactComponent };